import React from "react";
import { Target, Lightbulb, Shield, Users, GlassWater } from "lucide-react";
import HeroSection from "../components/HeroSection";
import servicesHero from "../assets/images/services-hero.jpg";
import businessSolutions from "../assets/images/services/business-solutions.jpg";
import technologyServices from "../assets/images/services/technology-services.jpg";
import facilityManagement from "../assets/images/services/facility-management.jpg";
import humanCapital from "../assets/images/services/human-capital.jpg";
import dairyProducts from "../assets/images/services/dairy-products.png";

export default function ServicesPage() {
  const serviceCategories = [
    {
      title: "Business Solutions",
      icon: <Target size={48} />,
      image: businessSolutions,
      services: ["Strategic Consulting", "Debt Collection", "Business Process Optimization"],
    },
    {
      title: "Technology Services",
      icon: <Lightbulb size={48} />,
      image: technologyServices,
      services: [
        "Software Development",
        "Web Development",
        "ID Printing",
        "Fleet Tracking",
      ],
    },
    {
      title: "Facility Management",
      icon: <Shield size={48} />,
      image: facilityManagement,
      services: ["Cleaning Services", "Security Services"],
    },
    {
      title: "Human Capital",
      icon: <Users size={48} />,
      image: humanCapital,
      services: ["Recruitment", "HR Consulting", "Payroll Services"],
    },
    {
      title: "Dairy Products",
      icon: <GlassWater size={48} />,
      image: dairyProducts,
      services: [
        "Banana Yogurt",
        "Strawberry Yogurt",
        "Pineapple Yogurt",
        "Orange Yogurt",
      ],
      services: [
        "Banana Yogurt",
        "Strawberry Yogurt",
        "Pineapple Yogurt",
        "Orange Yogurt",
        "Marula Yogurt",
      ],
    },
  ];

  return (
    <>
      <HeroSection
        title="OUR SERVICES"
        description="Ours is an innovative family that is driven by a holistic understanding of the consequences of our business dealings."
        imageUrl={servicesHero}
        overlay="accent"
        align="center"
      />

      <section className="services-container">
        <div className="services-wrapper">
          {serviceCategories.map((category, index) => (
            <div key={index} className="service-card">
              <div className="service-image">
                <img src={category.image} alt={category.title} loading="lazy" />
              </div>
              <div className="service-content">
                <div className="service-icon">{category.icon}</div>
                <h3 className="service-title">{category.title}</h3>
                <ul className="service-list">
                  {category.services.map((service, idx) => (
                    <li key={idx}>{service}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
